import { useI18n } from '@oneaudi/i18n-context';
import { SYS_SPACE_FIXED_200 } from '@oneaudi/unified-web-common';
import { Text, TextLink } from '@oneaudi/unified-web-components';
import { GfaLayerManagerV1 } from '@volkswagen-onehub/gfa-layer-manager';
import { FocusLayerSizeV2 } from '@volkswagen-onehub/layer-manager';

import { useServicesContext } from '@oneaudi/vtp-shared';
import React, { useCallback, useState } from 'react';
import ReactDOM from 'react-dom';
import { ModalContentContainer, StyledConatiner } from './styles';
import { AudiFeatureAppTyreLabelTyreLabelItem, TyreLabel } from './TyreLabel';
import { tyreLabelTracking } from './tracking';
import { TrackingServiceV2 } from '@oneaudi/audi-tracking-service';

interface TyreLabelProps {
  tyreLabels: {
    mainTyreLabels: Array<AudiFeatureAppTyreLabelTyreLabelItem>;
    additionalTyreLabels: Array<AudiFeatureAppTyreLabelTyreLabelItem>;
  };
}

export const TyreDetails: React.FC<TyreLabelProps> = ({ tyreLabels }) => {
  const tyreLabelButtonText = useI18n({
    id: 'fa.audi-feature-app-tyre-label-link.tyre-label-link',
  });

  const trackingService = useServicesContext().getAdditionalService(
    'audi-tracking-service'
  ) as TrackingServiceV2;

  const seeMoreLabelText = useI18n({
    id: 'stockcars.equipment.tyre.info',
    defaultMessage: '',
  });

  const layerManager = useServicesContext().getAdditionalService(
    'gfa:layer-manager'
  ) as GfaLayerManagerV1;
  const [layerNode, setLayerNode] = useState<Element | null>();
  const layerRef = useCallback(
    (node: Element | null) => {
      setLayerNode(node);
    },
    [setLayerNode]
  );
  const openLayer = () => {
    layerManager.openFocusLayer(
      () => <div ref={layerRef} />,
      {},
      {
        size: FocusLayerSizeV2.A,
        userCloseable: true,
      }
    );
    tyreLabelTracking(trackingService, tyreLabelButtonText);
  };

  return (
    <StyledConatiner key="tyreLabel">
      <Text
        variant={{ type: 'copy', order: '1', style: 'normal' }}
        tag="label"
        data-testid="tyreLabel"
      >
        {tyreLabelButtonText}
      </Text>
      {seeMoreLabelText && (
        <TextLink
          variant="standalone"
          icon="external-link"
          iconPosition="trailing"
          size="sm"
          margin={[SYS_SPACE_FIXED_200]}
          onClick={openLayer}
          data-testid="TyreLabelInfo"
          aria-label={tyreLabelButtonText}
        >
          {seeMoreLabelText}
        </TextLink>
      )}
      {layerNode &&
        ReactDOM.createPortal(
          <ModalContentContainer>
            <TyreLabel tyreLabels={tyreLabels} />
          </ModalContentContainer>,
          layerNode
        )}
    </StyledConatiner>
  );
};
